

//*************************DO NOT MODIFY**************************
//
//THESE FILES ARE AUTOGENERATED WITH TYPEWRITER AND ANY MODIFICATIONS MADE HERE WILL BE LOST
//PLEASE VISIT http://frhagn.github.io/Typewriter/ TO LEARN MORE ABOUT THIS VISUAL STUDIO EXTENSION
//
//*************************DO NOT MODIFY**************************
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { UtilisateursForListViewModel } from '../models/UtilisateursForListViewModel';
import { UtilisateurForDropdownModel } from '../models/UtilisateurForDropdownModel';
import { UtilisateurEditModel } from '../models/UtilisateurEditModel';
import { RoleModel } from '../models/RoleModel';
import { PermissionModel } from '../models/PermissionModel';
import { EtablissementUtilisateurModel } from '../models/EtablissementUtilisateurModel';
import { EtablissementUtilisateurFonctionModel } from '../models/EtablissementUtilisateurFonctionModel';
import { IdNomOrdreModel } from '../models/IdNomOrdreModel';

@Injectable({
   providedIn: 'root'
})
export class UtilisateurApiService {
    constructor(private _httpClient: HttpClient) { }        
    
    // get: api/Utilisateur/getUtilisateurs?first=${first}&rows=${rows}&sortField=${encodeURIComponent(sortField)}&sortOrder=${sortOrder}&total=${total}&filter=${encodeURIComponent(filter)}&nom=${encodeURIComponent(nom)}&prenom=${encodeURIComponent(prenom)}&email=${encodeURIComponent(email)}&siteId=${siteId}&avecRole=${avecRole}
    getUtilisateurs(first: number, rows: number, sortField: string, sortOrder: number, total: number, filter: string, nom: string, prenom: string, email: string, siteId: number, avecRole: number): Observable<UtilisateursForListViewModel> {
        var _Url = `api/Utilisateur/getUtilisateurs?first=${first}&rows=${rows}&sortField=${encodeURIComponent(sortField)}&sortOrder=${sortOrder}&total=${total}&filter=${encodeURIComponent(filter)}&nom=${encodeURIComponent(nom)}&prenom=${encodeURIComponent(prenom)}&email=${encodeURIComponent(email)}&siteId=${siteId}&avecRole=${avecRole}`;
            return this._httpClient.get<UtilisateursForListViewModel>(_Url).pipe(catchError(this.handleError));
    }
    
    // get: api/Utilisateur/getUtilisateursForDropdown?etablissementId=${etablissementId}&siteId=${siteId}
    getUtilisateursForDropdown(etablissementId: number, siteId: number): Observable<UtilisateurForDropdownModel[]> {
        var _Url = `api/Utilisateur/getUtilisateursForDropdown?etablissementId=${etablissementId}&siteId=${siteId}`;
            return this._httpClient.get<UtilisateurForDropdownModel[]>(_Url).pipe(catchError(this.handleError));
    }
    
    // get: api/Utilisateur/getUtilisateurEdit?utilisateurId=${utilisateurId}
    getUtilisateurEdit(utilisateurId: number): Observable<UtilisateurEditModel> {
        var _Url = `api/Utilisateur/getUtilisateurEdit?utilisateurId=${utilisateurId}`;
            return this._httpClient.get<UtilisateurEditModel>(_Url).pipe(catchError(this.handleError));
    }
    
    // post: api/Utilisateur/save
    save(utilisateur: UtilisateurEditModel): Observable<boolean> {
        var _Url = `api/Utilisateur/save`;
            return this._httpClient.post<boolean>(_Url, utilisateur).pipe(catchError(this.handleError));
    }
    
    // get: api/Utilisateur/getRoles?typeEtablissementId=${typeEtablissementId}
    getRoles(typeEtablissementId: number): Observable<RoleModel[]> {
        var _Url = `api/Utilisateur/getRoles?typeEtablissementId=${typeEtablissementId}`;
            return this._httpClient.get<RoleModel[]>(_Url).pipe(catchError(this.handleError));
    }
    
    // get: api/Utilisateur/getAllRoles
    getAllRoles(): Observable<RoleModel[]> {
        var _Url = `api/Utilisateur/getAllRoles`;
            return this._httpClient.get<RoleModel[]>(_Url).pipe(catchError(this.handleError));
    }
    
    // post: api/Utilisateur/saveRoleOrdre
    saveRoleOrdre(roles: RoleModel[]): Observable<boolean> {
        var _Url = `api/Utilisateur/saveRoleOrdre`;
            return this._httpClient.post<boolean>(_Url, roles).pipe(catchError(this.handleError));
    }
    
    // post: api/Utilisateur/saveRole
    saveRole(role: RoleModel): Observable<RoleModel> {
        var _Url = `api/Utilisateur/saveRole`;
            return this._httpClient.post<RoleModel>(_Url, role).pipe(catchError(this.handleError));
    }
    
    // get: api/Utilisateur/getAllPermissions
    getAllPermissions(): Observable<PermissionModel[]> {
        var _Url = `api/Utilisateur/getAllPermissions`;
            return this._httpClient.get<PermissionModel[]>(_Url).pipe(catchError(this.handleError));
    }
    
    // post: api/Utilisateur/deleteRole?id=${id}
    deleteRole(id: number): Observable<boolean> {
        var _Url = `api/Utilisateur/deleteRole?id=${id}`;
            return this._httpClient.post<boolean>(_Url, id).pipe(catchError(this.handleError));
    }
    
    // get: api/Utilisateur/getEtablissementUtilisateurs
    getEtablissementUtilisateurs(): Observable<EtablissementUtilisateurModel[]> {
        var _Url = `api/Utilisateur/getEtablissementUtilisateurs`;
            return this._httpClient.get<EtablissementUtilisateurModel[]>(_Url).pipe(catchError(this.handleError));
    }
    
    // post: api/Utilisateur/saveEtablissementUtilisateur
    saveEtablissementUtilisateur(utilisateurFonction: EtablissementUtilisateurFonctionModel): Observable<EtablissementUtilisateurFonctionModel> {
        var _Url = `api/Utilisateur/saveEtablissementUtilisateur`;
            return this._httpClient.post<EtablissementUtilisateurFonctionModel>(_Url, utilisateurFonction).pipe(catchError(this.handleError));
    }
    
    // post: api/Utilisateur/deleteEtablissementUtilisateur?id=${id}
    deleteEtablissementUtilisateur(id: number): Observable<boolean> {
        var _Url = `api/Utilisateur/deleteEtablissementUtilisateur?id=${id}`;
            return this._httpClient.post<boolean>(_Url, id).pipe(catchError(this.handleError));
    }
    
    // get: api/Utilisateur/getFonctions
    getFonctions(): Observable<IdNomOrdreModel[]> {
        var _Url = `api/Utilisateur/getFonctions`;
            return this._httpClient.get<IdNomOrdreModel[]>(_Url).pipe(catchError(this.handleError));
    }
    
    // Utility
    private handleError(error: HttpErrorResponse) {
        console.error(error);
        let customError: string = "";
        if (error.error) {
            customError = error.status === 400 ? error.error : error.statusText
        }
        return throwError(customError || 'Server error');
    }
}
